/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2023 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

"use client";

import ImageGridList from '@/components/ImageGrid/index'
import { Heading, View } from '@adobe/react-spectrum';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

export default function SimilarImages({ data, locale, query, token }) {
    const t = useTranslations("");
    useEffect(() => {
    }, [locale, data, query])

    const images: Array<any> = data._embedded.assets.map((asset: any) => ({
        after_url: `https://${process.env.NEXT_PUBLIC_cpApiHost}/${process.env.NEXT_PUBLIC_dcx_path}/${asset.id}/rendition/images/initial/version/0/format/jpg/dimension/width/size/400`,
        id: asset.id,
        locale: locale,
        url: asset._links.rendition?.href.replace('{format}', 'jpg').replace('{dimension}', 'width').replace('{size}', '400'),
        owner: asset._embedded.owner._links.images[5]?.href,
        owner_id: asset._embedded.owner.id
    }));

    return (
        <div className="container">
            <View>
                <Heading level={1}>{t("similar_images")}</Heading>
                <ImageGridList query={query} imageData={images} nextCursor={data._links.next?.href} locale={locale} token={token} />
            </View>
        </div>
    );
}